import { Component, Input } from '@angular/core';
import { TranslatePipe} from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { CompanyModel } from "../../../models/company.model";
import { TeamModel } from "../../../models/team.model";

@Component({
    selector: 'app-map-statistic-circles',
    templateUrl: './map-statistic-circles.component.html',
    styleUrls: ['./map-statistic-circles.component.scss'],
    imports: [
      TranslatePipe,
      IonicModule
    ],
    standalone: true
})
export class MapStatisticCirclesComponent {
  @Input() organization?: CompanyModel | null = null;
  @Input() space?: TeamModel | null = null;

  // 🔹 Labels
  get membersLabel(): string {
    if (this.organization) return 'lbl_user_adopts';
    if (this.space) return 'lbl_members';
    return 'lbl_user_adopts';
  }

  // 🔹 Values
  get actionPointsValue(): number {
    if (this.organization) return this.organization.actionPointCount ?? 0;
    if (this.space) return Number(this.space.actionPointCount ?? 0);
    return 0;
  }

  get impactScoreValue(): number {
    if (this.organization) return this.organization.impactScore ?? 0;
    if (this.space) return Number(this.space.impactScore ?? 0);
    return 0;
  }

  get avgImpactScoreValue(): number {
    if (this.organization) return this.organization.avgEmployeeImpactScore ?? 0;
    if (this.space) return this.space.averageImpactScore ?? 0;
    return 0;
  }

  get memberOrAdoptionValue(): number {
    if (this.organization) return Number(this.organization.adoptionCount) ?? 0;
    if (this.space) return Number(this.space.membersCount ?? 0);
    return 0;
  }
}
